import pubsub from '../pubsub.js';

export default function (...args)
{
	return pubsub({

		captureEvents(_this = this)
		{
			_this.register(_this.getId());		// Need to be called with _this so pubsub registers the proper object 
			this.safeProtoCall(_this);
		},

		setValue(value, _this = this)
		{
			this.safeProtoCall(value, _this);
			_this.publish('change', value);
		},

	});
}

